import { useMutation } from "react-query";
import { X } from "lucide-react";
import { addAdminUser } from "../../sdk/users/users";
import { useError } from "../../context/ErrorProvider";
import Loading from "../../shared/Loading";

const ReviewAddUser = ({
  closeReviewAddUser,
  handleReviewAddUser,
  adminUser,
  getUsers,
  setAdminUser,
  handleBackToAddUser,
}) => {
  const { showError } = useError();

  const { mutate, isLoading } = useMutation({
    mutationFn: () =>
      addAdminUser(
        adminUser.email,
        adminUser.username,
        adminUser.firstName,
        adminUser.lastName,
        adminUser.phoneNumber,
        adminUser.role.id,
        adminUser.branch.id,
        adminUser.profileUrl,
      ),
    onSuccess: () => {
      getUsers();
      setAdminUser({
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: null,
        branch: null,
      });
      handleReviewAddUser();
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleAddAdmin = () => {
    mutate();
  };
  return (
    <div
      onClick={(e) => {
        closeReviewAddUser();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[750px] h-[500px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeReviewAddUser}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[10px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[20px] left-[20px] flex items-center justify-between right-[20px]">
          <button
            onClick={handleBackToAddUser}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#222222] font-medium"
          >
            Back
          </button>
          <button
            disabled={isLoading}
            onClick={handleAddAdmin}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            {isLoading && <Loading />}
            Add User
          </button>
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Review and Finish
          </p>
          <p className="text-[#5C5C5C] text-[15px] font-normal">
            Great work! You've provided all the necessary details for the new
            user. Take a moment to review and confirm the settings below:
          </p>
          <div className="h-[30px] my-[20px] border-b-[1px] border-[#A8A8A8] bg-white flex items-center justify-between">
            <p className="text-[#5C5C5C] text-[16px] font-normal">Username</p>
            <p className="text-[#000000] font-bold text-[16px]">
              {adminUser?.username}
            </p>
          </div>
          <div className="h-[30px] my-[20px] border-b-[1px] border-[#A8A8A8] bg-white flex items-center justify-between">
            <p className="text-[#5C5C5C] text-[16px] font-normal">Full Name</p>
            <p className="text-[#000000] font-bold text-[16px]">
              {adminUser?.firstName} {adminUser?.lastName}
            </p>
          </div>
          <div className="h-[30px] my-[20px] border-b-[1px] border-[#A8A8A8] bg-white flex items-center justify-between">
            <p className="text-[#5C5C5C] text-[16px] font-normal">
              Email Address
            </p>
            <p className="text-[#000000] font-bold text-[16px]">
              {adminUser?.email ?? "N/A"}
            </p>
          </div>
          <div className="h-[30px] my-[20px] border-b-[1px] border-[#A8A8A8] bg-white flex items-center justify-between">
            <p className="text-[#5C5C5C] text-[16px] font-normal">Phone</p>
            <p className="text-[#000000] font-bold text-[16px]">
              {adminUser?.phoneNumber}
            </p>
          </div>
          <div className="h-[30px] my-[20px] border-b-[1px] border-[#A8A8A8] bg-white flex items-center justify-between">
            <p className="text-[#5C5C5C] text-[16px] font-normal">Branch</p>
            <p className="text-[#000000] font-bold text-[16px]">
              {adminUser?.branch?.name}
            </p>
          </div>
          <div className="h-[30px] my-[20px] border-b-[1px] border-[#A8A8A8] bg-white flex items-center justify-between">
            <p className="text-[#5C5C5C] text-[16px] font-normal">Role</p>
            <p className="text-[#000000] font-bold text-[16px]">
              {adminUser.role?.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewAddUser;
